
// Main entry point file for the BlockStack game
import { initGame } from './gameInitializer';

// Export the main initialization function
export function initBlockStackGame(containerId) {
  return new Promise((resolve, reject) => {
    try {
      // Add a small delay to ensure DOM is fully ready
      setTimeout(() => {
        // Check if container exists
        const container = document.getElementById(containerId);
        if (!container) {
          console.error(`Container with ID ${containerId} not found`);
          return reject(new Error(`Container with ID ${containerId} not found`));
        }

        // Make sure Phaser is defined
        if (typeof window.Phaser === 'undefined') {
          console.error('Phaser is not defined in initBlockStackGame');
          return reject(new Error('Game engine not loaded. Please refresh the page and try again.'));
        }

        // Initialize the game once we're sure Phaser is loaded
        console.log('Initializing BlockStack game with Phaser version:', window.Phaser.VERSION);
        initGame(containerId).then(resolve).catch(reject);
      }, 300);
    } catch (error) {
      console.error('Error in initBlockStackGame:', error);
      reject(error);
    }
  });
}

// Add a health check function that can be called to verify Phaser is working
export function checkPhaserAvailability() {
  if (typeof window.Phaser === 'undefined') {
    return { available: false, message: 'Phaser not loaded' };
  }
  return { available: true, version: window.Phaser.VERSION };
}
